/* @flow */
import {asyncComponent} from 'react-async-component';
import FooterPlaceholder from './FooterPlaceholder';

/**
 * Use a webpackChunkName for consistent chunk names of async modules
 * See https://webpack.js.org/api/module-methods/#import
 */
export default asyncComponent({
    resolve: () => import(/* webpackChunkName: "AsyncFooter" */ './Footer'),
    name: 'AsyncFooter',
    serverMode: 'defer',
    LoadingComponent: FooterPlaceholder
});
